<template>
  <div class="container">
    <Loading v-if="pageLoading" />
    <div class="width_wrap">
      <MyPageSidebar />
      <div class="body_content sub">
        <h1 class="sub_subject" style="margin-bottom: 20px">
          {{
            pidFromRoute == constant.OrderType.SURVEY
              ? "[기관] 검사 및 상담코칭 신청서 작성"
              : pidFromRoute == constant.OrderType.ACTIVITY
              ? "[기관] Activity 신청서 작성"
              : pidFromRoute == constant.OrderType.EXPERT
              ? "[기관] 전문가 교육 신청서 작성"
              : "기관 신청서 작성"
          }}
        </h1>
        <n-form
          ref="requestFormRef"
          :model="formModel"
          :rules="formRules"
          label-placement="left"
          require-mark-placement="right-hanging"
        >
          <n-card title="기관 정보" style="margin-top: 20px">
            <n-descriptions
              v-if="formModel.client"
              label-placement="left"
              :column="2"
              size="small"
              bordered
              class="org-info-descriptions"
              style="margin-bottom: 10px"
            >
              <n-descriptions-item label="기관명" span="2">{{
                formModel.client.name || "N/A"
              }}</n-descriptions-item>
              <n-descriptions-item label="대표자 이름">{{
                formModel.client.president || "N/A"
              }}</n-descriptions-item>
              <n-descriptions-item label="기관 유형">{{
                common.getOrganizationTypeString(
                  formModel.client.type as OrganizationType
                )
              }}</n-descriptions-item>
              <n-descriptions-item label="기관 주소" span="2"
                >{{ formModel.client.address.address || "" }}
                {{
                  formModel.client.address.addressDetail || ""
                }}</n-descriptions-item
              >
              <n-descriptions-item label="담당부서명">
                <n-form-item
                  path="client.dept"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-input
                    v-model:value="formModel.client.dept"
                    placeholder="담당부서"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="전화번호">
                <n-form-item
                  path="client.phoneNumber"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-input
                    v-model:value="formModel.client.phoneNumber"
                    placeholder="010-1234-5678"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="담당자 성명">
                <n-form-item
                  path="client.deptPersonName"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-input
                    v-model:value="formModel.client.deptPersonName"
                    placeholder="담당자명"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="핸드폰번호">
                <n-form-item
                  path="client.deptPersonPhoneNumber"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-input
                    v-model:value="formModel.client.deptPersonPhoneNumber"
                    placeholder="010-1234-5678"
                  />
                </n-form-item>
              </n-descriptions-item>
              <n-descriptions-item label="이메일" span="2">
                <n-form-item
                  path="client.email"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-input
                    v-model:value="formModel.client.email"
                    placeholder="contact@example.com"
                  /> </n-form-item
              ></n-descriptions-item>
            </n-descriptions>
          </n-card>
          <template
            v-if="
              pidFromRoute == constant.OrderType.SURVEY ||
              pidFromRoute == constant.OrderType.ACTIVITY
            "
          >
            <n-card
              v-if="orgType == OrganizationType.Etc"
              title="검사 대상 선택"
              style="margin-top: 20px"
            >
              <n-radio-group
                v-model:value="selectedOrgType"
                name="orgTypeSelection"
              >
                <n-space>
                  <n-radio
                    :key="OrganizationType.ElementarySchool"
                    :value="OrganizationType.ElementarySchool"
                    label="초등학교"
                  />
                  <n-radio
                    :key="OrganizationType.MiddleSchool"
                    :value="OrganizationType.MiddleSchool"
                    label="증학교"
                  />
                  <n-radio
                    :key="OrganizationType.HighSchool"
                    :value="OrganizationType.HighSchool"
                    label="고등학교"
                  />
                  <n-radio
                    :key="OrganizationType.University"
                    :value="OrganizationType.University"
                    label="대학교"
                  />
                </n-space>
              </n-radio-group>
            </n-card>
            <template v-if="pidFromRoute == constant.OrderType.SURVEY">
              <n-card title="검사 종류 선택" style="margin-top: 20px">
                <n-form-item path="selectedSurveySK" label-placement="left">
                  <n-radio-group
                    v-model:value="formModel.selectedSurveySK"
                    name="surveySelection"
                  >
                    <n-space>
                      <n-radio
                        v-for="survey in surveySet"
                        :key="survey.SK"
                        :value="survey.SK!"
                        :label="survey.name"
                      />
                    </n-space>
                  </n-radio-group>
                </n-form-item>
              </n-card>

              <div v-if="formModel.selectedSurveySK">
                <n-card
                  title="코칭 상품 선택 (다중 선택 가능)"
                  style="margin-top: 20px"
                >
                  <n-checkbox-group v-model:value="selectedCoachSKsForBoth">
                    <n-space item-style="display: flex;">
                      <n-checkbox
                        v-for="coach in coachSet"
                        :key="coach.SK"
                        :value="coach.SK!"
                        :label="coach.name"
                      />
                    </n-space>
                  </n-checkbox-group>
                </n-card>
              </div>
            </template>
            <template v-else>
              <n-card
                title="상품 선택 (다중 선택 가능)"
                style="margin-top: 20px"
              >
                <n-checkbox-group v-model:value="selectedActivitySKs">
                  <n-space vertical item-style="display: flex;">
                    <n-checkbox
                      v-for="acitivy in activitySet"
                      :key="acitivy.SK"
                      :value="acitivy.SK!"
                      :label="acitivy.name"
                    />
                  </n-space>
                </n-checkbox-group>
              </n-card>
            </template>

            <n-card title="신청 상품 및 수량" style="margin-top: 20px">
              <div
                v-for="(item, index) in formModel.products"
                :key="item.prod_id"
                class="product-request-item"
              >
                <n-descriptions
                  :title="item.name"
                  label-placement="left"
                  :column="3"
                  size="small"
                  bordered
                >
                  <n-descriptions-item
                    v-if="isUniversity(item)"
                    label="학과"
                    label-placement="left"
                    style="text-align: right"
                    labelStyle="width:100px"
                  >
                    <n-input v-model:value="item.major" placeholder="학과" />
                  </n-descriptions-item>
                  <n-descriptions-item
                    label="학년"
                    label-placement="left"
                    style="text-align: right"
                    labelStyle="width:100px"
                  >
                    <n-input v-model:value="item.grade" placeholder="학년" />
                  </n-descriptions-item>
                  <n-descriptions-item
                    v-if="!isUniversity(item)"
                    label="학급수"
                    label-placement="left"
                    labelStyle="width:100px"
                  >
                    <n-input
                      v-model:value="item.class_num"
                      placeholder="학급수"
                    />
                  </n-descriptions-item>

                  <n-descriptions-item
                    label=""
                    label-placement="left"
                    labelStyle="width:100px"
                  >
                    &nbsp;
                  </n-descriptions-item>
                  <n-descriptions-item
                    label="단가(원)"
                    contentStyle="text-align: right"
                  >
                    {{ common.formatNumberWithCommas(Number(item.unit_price)) }}
                  </n-descriptions-item>
                  <n-descriptions-item
                    :path="`products[${index}].quantity`"
                    :rule="formRules.quantityRule"
                    label="총인원수"
                  >
                    <n-input-number
                      v-model:value="item.quantity"
                      placeholder="수량"
                      :min="1"
                    />
                  </n-descriptions-item>
                  <n-descriptions-item
                    label="금액(원)"
                    contentStyle="text-align: right"
                  >
                    {{
                      common.formatNumberWithCommas(
                        Number(item.unit_price) * item.quantity
                      )
                    }}
                  </n-descriptions-item>
                </n-descriptions>
              </div>
              <div
                v-if="formModel.products.length > 0"
                class="total-unit_price-section"
              >
                <n-grid :cols="12" :x-gap="12">
                  <n-gi :span="7"></n-gi>
                  <n-gi
                    :span="5"
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 1.1em;
                    "
                  >
                    총 결제 금액:
                    {{ common.formatNumberWithCommas(totalPrice) }}원
                  </n-gi>
                </n-grid>
              </div>
              <div style="margin-top: 20px">
                <n-grid :cols="12" :x-gap="12">
                  <n-gi :span="12">
                    <n-form-item label="검사 실시 예정일" path="test_due_date">
                      <n-date-picker
                        v-model:formatted-value="formModel.test_due_date"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="검사 실시 예정일 선택"
                        style="width: 200px"
                      />
                    </n-form-item>
                  </n-gi>
                  <n-gi :span="12" style="padding-top: 5px">
                    <n-form-item
                      v-if="selectedCoachSKsForBoth.length > 0"
                      label="상담 코칭 예정일"
                      path="coaching_due_date"
                    >
                      <n-date-picker
                        v-model:formatted-value="formModel.coaching_due_date"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="상담 코칭 예정일 선택"
                        style="width: 200px"
                      />
                      <span style="margin-left: 10px; color: red"
                        >(일정은 검사 완료 및 결과리포트를 수령, 확인 후이어야
                        함. 042-867-5558)</span
                      >
                    </n-form-item>
                  </n-gi>
                </n-grid>
              </div>
            </n-card>
          </template>
          <template v-else>
            <n-card title="상품 선택 (다중 선택 가능)" style="margin-top: 20px">
              <n-checkbox-group v-model:value="selectedExpertSKs">
                <n-space vertical item-style="display: flex;">
                  <n-checkbox
                    v-for="expert in expertSet"
                    :key="expert.SK"
                    :value="expert.SK!"
                    :label="expert.name"
                  />
                </n-space>
              </n-checkbox-group>
            </n-card>
            <n-card title="신청 상품 및 수량" style="margin-top: 20px">
              <div
                v-for="(item, index) in formModel.products"
                :key="item.prod_id"
                class="product-request-item"
              >
                <n-descriptions
                  :title="item.name"
                  label-placement="left"
                  :column="3"
                  size="small"
                  bordered
                >
                  <n-descriptions-item
                    label="단가(원)"
                    contentStyle="text-align: right"
                  >
                    {{ common.formatNumberWithCommas(Number(item.unit_price)) }}
                  </n-descriptions-item>
                  <n-descriptions-item
                    :path="`products[${index}].quantity`"
                    :rule="formRules.quantityRule"
                    label="총인원수"
                  >
                    <n-input-number
                      v-model:value="item.quantity"
                      placeholder="수량"
                      :min="1"
                    />
                  </n-descriptions-item>
                  <n-descriptions-item
                    label="금액(원)"
                    contentStyle="text-align: right"
                  >
                    {{
                      common.formatNumberWithCommas(
                        Number(item.unit_price) * item.quantity
                      )
                    }}
                  </n-descriptions-item>
                </n-descriptions>
              </div>
              <div
                v-if="formModel.products.length > 0"
                class="total-unit_price-section"
              >
                <n-grid :cols="12" :x-gap="12">
                  <n-gi :span="7"></n-gi>
                  <n-gi
                    :span="5"
                    style="
                      text-align: right;
                      font-weight: bold;
                      font-size: 1.1em;
                    "
                  >
                    총 결제 금액:
                    {{ common.formatNumberWithCommas(totalPrice) }}원
                  </n-gi>
                </n-grid>
              </div>
            </n-card>
          </template>
          <n-card title="결제 정보" style="margin-top: 20px">
            <n-descriptions
              label-placement="left"
              :column="2"
              size="small"
              bordered
            >
              <n-descriptions-item
                label="결제계좌"
                label-placement="left"
                style="text-align: right"
                labelStyle="width:100px;"
                contentStyle="text-align: center; ;align-content: center;"
              >
                {{ formModel.payment_method.bank_name || "N/A" }}
              </n-descriptions-item>
              <n-descriptions-item
                label="입금예정일"
                label-placement="left"
                labelStyle="width:100px"
              >
                <n-form-item
                  path="payment_method.bank_date"
                  :show-label="false"
                  style="margin-bottom: 0"
                >
                  <n-date-picker
                    v-model:formatted-value="formModel.payment_method.bank_date"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="입금 예정일 선택"
                    style="width: 100%"
                  />
                </n-form-item>
              </n-descriptions-item>
            </n-descriptions>
          </n-card>
          <div style="text-align: right; margin-top: 24px; margin-bottom: 20px">
            <n-button @click="handleCancel" style="margin-right: 12px"
              >취소</n-button
            >
            <n-button
              type="primary"
              @click="handleSubmitRequest"
              :loading="submitLoading"
              >기관 신청서 제출</n-button
            >
          </div>
        </n-form>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, watch } from "vue";
import {
  NForm,
  NFormItem,
  NGi,
  NFormItemGi,
  NInput,
  NButton,
  NInputNumber,
  NCard,
  NGrid,
  useMessage,
  useNotification,
  FormInst,
  FormRules,
  NRadioGroup,
  NRadio,
  NCheckboxGroup,
  NCheckbox,
  NSpace,
  NDescriptions,
  NDescriptionsItem,
  NDatePicker,
} from "naive-ui";
import MyPageSidebar from "@/views/member/MypageSidebar.vue";
import Loading from "@/components/Loading.vue";
import * as common from "@/assets/common/common";
import { USER_ROUTES } from "@/assets/route_constants";
import { getCallable } from "@/config/env";
import { OrgUser, Organization, OrganizationType } from "@/model/organization";
import { Product } from "@/model/product";
import { Order, OrderItem } from "@/model/order";
import { useAlertDialog } from "@/composables/useAlert";
import { useRouter, useRoute } from "vue-router";
import * as constant from "@/constants/constant";
const useAlert = useAlertDialog();
const router = useRouter();
const route = useRoute();

const message = useMessage();
const notification = useNotification();

const pageLoading = ref(false);
const submitLoading = ref(false);
const requestFormRef = ref<FormInst | null>(null);

const prodSet = ref<Product[]>([]);
const surveySet = ref<Product[]>([]);
const coachSet = ref<Product[]>([]);
const activitySet = ref<Product[]>([]);
const expertSet = ref<Product[]>([]);

const selectedCoachSKsForBoth = ref<string[]>([]);
const selectedActivitySKs = ref<string[]>([]);
const selectedExpertSKs = ref<string[]>([]);

const pidFromRoute = ref<string | null>(null);
const orgType = ref<OrganizationType>(OrganizationType.ElementarySchool);
const selectedOrgType = ref<OrganizationType>(
  OrganizationType.ElementarySchool
);

const formModel = ref<
  Order & {
    selectedSurveySK?: string | null;
    test_due_date?: string | null;
    coaching_due_date?: string | null;
  }
>({
  order_id: "",
  SK: "",
  name: "",
  cc: "",
  receiver_email: "",
  client: null,
  payment_method: {
    bank_date: null,
    bank_name: "우리은행 : 1005-104-783814, 예금주:주식회사코코랩",
    deposit_name: "",
    type: "bank_deposit",
  },
  products: [],
  status: "",
  totalPrice: 0,
  type: constant.orderType.BODY,
  selectedSurveySK: null,
  test_due_date: null,
  coaching_due_date: null,
});

const totalPrice = computed(() => {
  return formModel.value.products.reduce((sum, product) => {
    const unit_price = product.unit_price || 0;
    const quantity = product.quantity || 0;
    product.supply_price = Number(unit_price) * quantity;
    return sum + Number(unit_price) * quantity;
  }, 0);
});

const availableProducts = ref<Array<{ label: string; value: string }>>([]);

const baseFormRules: FormRules = {
  "client.dept": [
    {
      required: true,
      message: "담당부서명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.phoneNumber": [
    {
      required: true,
      message: "전화번호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.deptPersonName": [
    {
      required: true,
      message: "담당자 성명을 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.deptPersonPhoneNumber": [
    {
      required: true,
      message: "핸드폰번호를 입력해주세요.",
      trigger: ["input", "blur"],
    },
  ],
  "client.email": [
    {
      required: true,
      message: "이메일을 입력해주세요.",
      trigger: ["input", "blur"],
    },
    {
      type: "email",
      message: "올바른 이메일 형식이 아닙니다.",
      trigger: ["input", "blur"],
    },
  ],
  "payment_method.bank_date": [
    {
      required: true,
      message: "입금예정일을 선택해주세요.",
      trigger: "change",
    },
  ],
  quantityRule: [
    {
      required: true,
      type: "number",
      message: "수량을 입력해주세요.",
      trigger: ["input", "blur"],
      min: 1,
    },
  ],
};

const surveyFormRules: FormRules = {
  ...baseFormRules,
  test_due_date: [
    {
      required: true,
      message: "검사실시 예정일을 선택해주세요.",
      trigger: "change",
    },
  ],
  // coaching_due_date: [
  //   {
  //     required: true,
  //     message: "상담코칭 예정일을 선택해주세요.",
  //     trigger: "change",
  //   },
  // ],
  selectedSurveySK: [
    { required: true, message: "검사 유형을 선택해주세요.", trigger: "change" },
  ],
};

const expertFormRules: FormRules = {
  ...baseFormRules,
};

const formRules: FormRules =
  (route.params.pid as string) == constant.OrderType.EXPERT
    ? expertFormRules
    : surveyFormRules;

const requestOrgQuotationCallable = getCallable("requestOrgQuotation");

function isUniversity(item: OrderItem): boolean {
  if (
    item.type == "putt_u" ||
    item.type == "tec" ||
    item.type == "coach_putt_u" ||
    item.type == "coach_tec" ||
    item.type == "coach_putt_tec"
  ) {
    return true;
  } else {
    return false;
  }
}

async function setSurveyProdItems() {
  surveySet.value = [];
  coachSet.value = [];
  const surveyBoth = {
    SK: "B",
    name: "",
  };
  const fullProdSet = await common.getProductSetList();
  if (selectedOrgType.value === OrganizationType.ElementarySchool) {
    prodSet.value = fullProdSet[0];
    surveyBoth.name = "PUTT2.0_초등학생용‧TOCC_아동용(고학년)";
  } else if (selectedOrgType.value === OrganizationType.MiddleSchool) {
    prodSet.value = fullProdSet[1];
    surveyBoth.name = "PUTT2.0_중학생용‧TOCC_청소년용";
  } else if (selectedOrgType.value === OrganizationType.HighSchool) {
    prodSet.value = fullProdSet[2];
    surveyBoth.name = "PUTT2.0_고등학생용‧TOCC_청소년용";
  } else if (selectedOrgType.value === OrganizationType.University) {
    prodSet.value = fullProdSet[3];
    surveyBoth.name = "PUTT2.0_대학생용‧TEC_전문가용";
  }
  for (const product of prodSet.value) {
    if (product.SK?.startsWith("personal")) {
      surveySet.value.push(product);
    } else {
      coachSet.value.push(product);
    }
  }
  surveySet.value.push(surveyBoth);
}

async function setActivityProdItems() {
  activitySet.value = [];
  const fullProdSet = common.getActivityProductSetList();
  if (selectedOrgType.value === OrganizationType.ElementarySchool) {
    prodSet.value = fullProdSet[0];
  } else if (selectedOrgType.value === OrganizationType.MiddleSchool) {
    prodSet.value = fullProdSet[1];
  } else if (selectedOrgType.value === OrganizationType.HighSchool) {
    prodSet.value = fullProdSet[2];
  } else if (selectedOrgType.value === OrganizationType.University) {
    prodSet.value = fullProdSet[3];
  }
  for (const product of prodSet.value) {
    activitySet.value.push(product);
  }
}

async function setExportProdItems() {
  if (expertSet.value && expertSet.value.length > 0) return;
  expertSet.value = [];
  const fullProdSet = common.getExpertProductSetList();
  for (const product of fullProdSet) {
    expertSet.value.push(product);
  }
}

async function setProdItems() {
  if (pidFromRoute.value == constant.OrderType.ACTIVITY) {
    await setActivityProdItems();
  } else if (pidFromRoute.value == constant.OrderType.EXPERT) {
    await setExportProdItems();
  } else if (pidFromRoute.value == constant.OrderType.SURVEY) {
    await setSurveyProdItems();
  } else {
    router.push({ name: USER_ROUTES.Price.Org.Name });
  }
}

onMounted(async () => {
  pidFromRoute.value = route.params.pid as string;
  pageLoading.value = true;
  try {
    const localAuthData = common.getLocalAuth();
    if (localAuthData) {
      if (localAuthData.org && typeof localAuthData.org === "object") {
        formModel.value.client = {
          uid: localAuthData.orgId,
          ...localAuthData.org,
        };
        formModel.value.payment_method.deposit_name = localAuthData.org.name;
        orgType.value = localAuthData.org.type;
        let determinedOrgType =
          orgType.value === OrganizationType.Etc
            ? OrganizationType.ElementarySchool
            : orgType.value;
        await setProdItems();
        if (selectedOrgType.value !== determinedOrgType) {
          selectedOrgType.value = determinedOrgType;
        } else {
          await setProdItems();
        }
      } else {
        pageLoading.value = false;
        await useAlert("기관 회원전용 페이지 입니다.");
        router.push({ name: USER_ROUTES.Home.Name });
      }
    } else {
      pageLoading.value = false;
      await useAlert("회원전용 페이지 입니다.");
      router.push({ name: USER_ROUTES.Home.Name });
    }
  } catch (err) {
    console.log(err);
  } finally {
    pageLoading.value = false;
  }
});

const updateRequestedProducts = () => {
  const oldProducts: Map<string, OrderItem> = new Map(
    formModel.value.products.map((p) => [p.prod_id, p])
  );
  const newProducts: OrderItem[] = [];

  if (!formModel.value.selectedSurveySK) {
    formModel.value.products = [];
    return;
  }

  const selectedSurveyProduct = surveySet.value.find(
    (s) => s.SK === formModel.value.selectedSurveySK
  );
  if (selectedSurveyProduct) {
    coachSet.value = [];
    if (selectedSurveyProduct.type?.startsWith("putt")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_putt") &&
          !product.type?.startsWith("coach_putt_tocc") &&
          !product.type?.startsWith("coach_putt_tec")
        ) {
          coachSet.value.push(product);
        }
      }
    } else if (selectedSurveyProduct.type?.startsWith("tocc")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_tocc")
        ) {
          coachSet.value.push(product);
        }
      }
    } else if (selectedSurveyProduct.type?.startsWith("tec")) {
      for (const product of prodSet.value) {
        if (
          !product.SK?.startsWith("personal") &&
          product.type?.startsWith("coach_tec")
        ) {
          coachSet.value.push(product);
        }
      }
    } else {
      for (const product of prodSet.value) {
        if (!product.SK?.startsWith("personal")) {
          coachSet.value.push(product);
        }
      }
    }

    if (formModel.value.selectedSurveySK === "B") {
      for (const surveyProduct of surveySet.value) {
        if (surveyProduct.SK === "B") continue;
        newProducts.push({
          prod_id: surveyProduct.SK!,
          name: surveyProduct.name,
          price: surveyProduct.price,
          type: surveyProduct.type,
          unit_price: surveyProduct.price,
          template_form_id: surveyProduct.template_form_id, // Ensure this property exists on surveyProduct or handle if optional
          quantity: oldProducts.get(surveyProduct.SK!)?.quantity || 1,
          supply_price: surveyProduct.price * 1,
          notes: "",
          grade: oldProducts.get(surveyProduct.SK!)?.grade || null,
          major: oldProducts.get(surveyProduct.SK!)?.major || null,
          class_num: oldProducts.get(surveyProduct.SK!)?.class_num || null,
        });
      }
    } else {
      newProducts.push({
        prod_id: selectedSurveyProduct.SK!,
        name: selectedSurveyProduct.name,
        price: selectedSurveyProduct.price,
        type: selectedSurveyProduct.type,
        unit_price: selectedSurveyProduct.price,
        template_form_id: selectedSurveyProduct.template_form_id, // Ensure this property exists or handle if optional
        quantity: oldProducts.get(selectedSurveyProduct.SK!)?.quantity || 1,
        supply_price: selectedSurveyProduct.price * 1,
        notes: "",
        grade: oldProducts.get(selectedSurveyProduct.SK!)?.grade || null,
        major: oldProducts.get(selectedSurveyProduct.SK!)?.major || null,
        class_num:
          oldProducts.get(selectedSurveyProduct.SK!)?.class_num || null,
      });
    }
  }

  // if (formModel.value.selectedSurveySK === "B") {
  selectedCoachSKsForBoth.value.forEach((coachSK) => {
    const coachProduct = coachSet.value.find((c) => c.SK === coachSK);
    if (coachProduct) {
      newProducts.push({
        prod_id: coachProduct.SK!,
        price: coachProduct.price,
        unit_price: coachProduct.price,
        name: coachProduct.name,
        quantity: oldProducts.get(coachProduct.SK!)?.quantity || 1,
        supply_price: coachProduct.price * 1,
        notes: "",
        grade: oldProducts.get(coachProduct.SK!)?.grade || null,
        major: oldProducts.get(coachProduct.SK!)?.major || null,
        class_num: oldProducts.get(coachProduct.SK!)?.class_num || null,
      });
    }
  });
  // } else {
  // const originalSurveys = surveySet.value.filter((s) => s.SK !== "B");
  // const originalCoaches = coachSet.value.filter((c) => c.SK !== "B");
  // const surveyIndex = originalSurveys.findIndex(
  //   (s) => s.SK === formModel.value.selectedSurveySK
  // );
  // if (surveyIndex !== -1 && surveyIndex < originalCoaches.length) {
  //   const correspondingCoach = originalCoaches[surveyIndex];
  //   if (correspondingCoach) {
  //     if (!newProducts.find((p) => p.prod_id === correspondingCoach.SK)) {
  //       newProducts.push({
  //         prod_id: correspondingCoach.SK!,
  //         name: correspondingCoach.name,
  //         price: correspondingCoach.price,
  //         unit_price: correspondingCoach.price,
  //         quantity: oldProducts.get(correspondingCoach.SK!)?.quantity || 1,
  //         supply_price: correspondingCoach.price * 1,
  //         notes: "",
  //         grade: oldProducts.get(correspondingCoach.SK!)?.grade || null,
  //         major: oldProducts.get(correspondingCoach.SK!)?.major || null,
  //         class_num:
  //           oldProducts.get(correspondingCoach.SK!)?.class_num || null,
  //       });
  //     }
  //   }
  // }
  // }
  formModel.value.products = newProducts;
};

const updateActivityRequestedProducts = async () => {
  const oldQuantities = new Map(
    formModel.value.products.map((p) => [p.prod_id, p.quantity])
  );
  const newProducts: OrderItem[] = [];
  for (const acitivySK of selectedActivitySKs.value) {
    const activityProduct = activitySet.value.find((c) => c.SK === acitivySK);
    if (activityProduct) {
      let prd = {
        prod_id: activityProduct.SK!,
        price: activityProduct.price,
        unit_price: activityProduct.price,
        name: activityProduct.name,
        type: activityProduct.type,
        quantity: oldQuantities.get(activityProduct.SK!) || 1,
        supply_price: activityProduct.price * 1,
        template_form_id: "",
        notes: "",
      };
      if (activityProduct.type?.startsWith("putt_")) {
        const findPutt: Product | undefined = await common.getProduct(
          activityProduct.type
        );
        if (findPutt) {
          prd.template_form_id = findPutt.template_form_id;
        }
      }
      newProducts.push(prd);
    }
  }
  formModel.value.products = newProducts;
};

const updateExpertRequestedProducts = async () => {
  const oldQuantities = new Map(
    formModel.value.products.map((p) => [p.prod_id, p.quantity])
  );
  const newProducts: OrderItem[] = [];
  for (const expertSK of selectedExpertSKs.value) {
    const expertProduct = expertSet.value.find((c) => c.SK === expertSK);
    if (expertProduct) {
      newProducts.push({
        prod_id: expertProduct.SK!,
        price: expertProduct.price,
        unit_price: expertProduct.price,
        name: expertProduct.name,
        type: expertProduct.type,
        quantity: oldQuantities.get(expertProduct.SK!) || 1,
        supply_price: expertProduct.price * 1,
        notes: "",
      });
    }
  }
  formModel.value.products = newProducts;
};

watch(
  () => formModel.value.selectedSurveySK,
  (newVal) => {
    // if (newVal !== "B" && newVal !== undefined) {
    //   // Check newVal is not undefined if it can be
    //   selectedCoachSKsForBoth.value = []; // Reset checkboxes if not "Both" survey
    // }
    updateRequestedProducts();
  }
);

watch(
  selectedCoachSKsForBoth,
  () => {
    // if (formModel.value.selectedSurveySK === "B") {
    updateRequestedProducts();
    // }
  },
  { deep: true }
);

watch(selectedActivitySKs, async () => {
  await updateActivityRequestedProducts();
});

watch(selectedExpertSKs, () => {
  updateExpertRequestedProducts();
});
watch(selectedOrgType, async (newType, oldType) => {
  if (newType && newType !== oldType) {
    pageLoading.value = true;
    await setProdItems();
    // 기관 유형이 변경되면 선택된 검사 및 코칭 상품 초기화
    formModel.value.selectedSurveySK = null;
    selectedCoachSKsForBoth.value = [];
    formModel.value.products = []; // 요청 상품 목록도 초기화
    pageLoading.value = false;
  }
});
async function handleSubmitRequest() {
  try {
    await requestFormRef.value?.validate();
    if (formModel.value.products.length === 0) {
      message.error("요청할 상품을 하나 이상 선택해주세요.");
      return;
    }
  } catch (errors) {
    await useAlert("입력 내용을 확인해주세요.");
    return;
  }

  submitLoading.value = true;
  try {
    const payload = {
      ...formModel.value,
      totalPrice: totalPrice.value,
    };
    const result = await requestOrgQuotationCallable(payload);
    if (common.evalFunctionResult(result)) {
      notification.success({
        title: "요청 성공",
        description:
          "견적 요청이 성공적으로 전송되었습니다. 담당자가 확인 후 연락드리겠습니다.",
        duration: 3000,
      });
      router.push({ name: USER_ROUTES.Mypage.Order.Org.RequestList.Name });
    } else {
      notification.error({
        title: "요청 실패",
        description:
          common.getResultError(result) || "견적 요청 중 오류가 발생했습니다.",
        duration: 3000,
      });
    }
  } catch (error: any) {
    console.error("견적 요청 실패:", error);
    notification.error({
      title: "오류 발생",
      description: `견적 요청 중 오류가 발생했습니다: ${
        error.message || "알 수 없는 오류"
      }`,
      duration: 3000,
    });
  } finally {
    submitLoading.value = false;
  }
}

function handleCancel() {
  router.back(); // Go back to the previous page (Table.vue)
}
</script>

<style scoped>
.body_content {
  padding: 20px;
}
.sub_subject {
  font-size: 1.8em;
  font-weight: 600;
  color: #333;
}
.product-request-item {
  padding: 10px;
  margin-bottom: 10px;
  border: 1px solid #eee;
  border-radius: 4px;
  background-color: #f9f9f9;
}
.product-request-item:last-child {
  margin-bottom: 0;
}

.unit_price-text {
  font-size: 0.9em;
  color: #555;
}
.total-unit_price-section {
  margin-top: 20px;
  padding-top: 15px;
  border-top: 1px solid #e0e0e0;
}
:deep(.n-descriptions-header) {
  font-size: 15px !important; /* 원하는 크기로 조절 */
}
</style>
